import { useToast } from "../../../../components/common/toasts/ToastContext";
import ErrorToast from "../../../../components/common/toasts/ErrorToast";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { premiumRequest } from "../../../../services/Premium";
import useUnsavedChanges from "../../../../hooks/useUnsavedChanges";
import useAsyncAction from "../../hooks/useAsyncAction";
import { Check, Field } from "../Fields";
import UserPicker from "../UserPicker";

/** Zapisuje dostęp i chroni formularz przed przypadkowym opuszczeniem strony. */
export default function CompanyMemberForm({
  member,
  members,
  token,
  url,
  listPath,
}) {
  const { notify } = useToast();
  const [userId, setUserId] = useState(member?.userId || "");
  const [manage, setManage] = useState(member?.manageDictionaries || false);
  const navigate = useNavigate();
  const release = useUnsavedChanges(
    userId !== (member?.userId || "") ||
      manage !== (member?.manageDictionaries || false),
  );
  const { busy, error, run } = useAsyncAction(url);
  const save = (event) => {
    event.preventDefault();
    run(async (isActive) => {
      await premiumRequest(token, url, {
        method: "PUT",
        data: { userId, manageDictionaries: manage },
      });
      if (isActive()) {
        release();
        notify("Zapisano dostęp użytkownika.");
        navigate(listPath, { replace: true });
      }
    });
  };
  return (
    <form onSubmit={save}>
      <ErrorToast message={error} />
      <fieldset disabled={busy}>
        {member ? (
          <Field label="Użytkownik" readOnly value={member.name} />
        ) : (
          <UserPicker
            token={token}
            label="Użytkownik"
            value={userId}
            disabled={busy}
            excludedIds={members.map((item) => item.userId)}
            onChange={(event) => setUserId(event.target.value)}
          />
        )}
        <Check
          label="Może edytować słowniki tej firmy"
          checked={manage}
          onChange={(event) => setManage(event.target.checked)}
        />
      </fieldset>
      <div className="premium-form-actions">
        <Link to={listPath} className="btn btn-outline-secondary">
          Anuluj
        </Link>
        <button disabled={busy || !userId} className="btn btn-primary">
          {member ? "Zapisz zmiany" : "Dodaj użytkownika"}
        </button>
      </div>
    </form>
  );
}
